import "./InstagramSection.css";

import {
  FaArrowRight,
  FaInstagram,
} from "react-icons/fa";

import logo from "../assets/logo.png";
import instagramQR from "../assets/Instagram.png";

import insta1 from "../assets/proyecto1.jpg";
import insta2 from "../assets/proyecto2.jpg";
import insta3 from "../assets/proyecto3.jpg";
import insta4 from "../assets/proyecto4.jpg";
import insta5 from "../assets/logo.png";

const instagramUrl =
  "https://www.instagram.com/yannaap_constructions/";

const fotos = [
  {
    id: 1,
    imagen: insta1,
    descripcion:
      "Fachada de Residencial YANNA I",
  },
  {
    id: 2,
    imagen: insta2,
    descripcion:
      "Apartamento Tipo A de Residencial YANNA I",
  },
  {
    id: 3,
    imagen: insta3,
    descripcion:
      "Apartamento Tipo B de Residencial YANNA I",
  },
  {
    id: 4,
    imagen: insta4,
    descripcion:
      "Apartamento Tipo C de Residencial YANNA I",
  },
  {
    id: 5,
    imagen: insta5,
    descripcion:
      "Logo de YANNA A&P Constructions",
  },
];

function InstagramSection() {
  return (
    <section
      className="instagram"
      id="instagram"
    >
      {/* ENCABEZADO */}

      <div className="instagram-header">
        <span>
          SÍGUENOS EN INSTAGRAM
        </span>

        <h2>
          Descubre nuestro día a día
        </h2>

        <p>
          Conoce el avance de nuestras obras,
          diseños exclusivos, nuevos proyectos
          y mucho más contenido.
        </p>

        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-user"
          aria-label="Abrir el perfil de Instagram de YANNA A&P Constructions"
        >
          <FaInstagram />

          @yannaap_constructions
        </a>
      </div>

      {/* CÓDIGO QR */}

      <div className="instagram-qr-section">
        <div className="instagram-qr-content">
          <span>
            ESCANEA Y SÍGUENOS
          </span>

          <h3>
            Conecta con nosotros en Instagram
          </h3>

          <p>
            Escanea el código QR desde tu teléfono
            para conocer nuestros proyectos,
            avances de obra y nuevas publicaciones.
          </p>

          <a
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-qr-link"
          >
            <FaInstagram />

            Abrir perfil

            <FaArrowRight />
          </a>
        </div>

        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="instagram-qr-image"
          aria-label="Abrir Instagram de YANNA A&P Constructions"
        >
          <img
            src={instagramQR}
            alt="Código QR del Instagram de YANNA A&P Constructions"
            loading="lazy"
            decoding="async"
          />
        </a>
      </div>

      {/* PUBLICACIONES */}

      <div className="instagram-grid">
        {fotos.map((foto) => (
          <a
            key={foto.id}
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="instagram-card"
            aria-label="Abrir el perfil de Instagram"
          >
            <img
              src={foto.imagen}
              alt={foto.descripcion}
              loading="lazy"
              decoding="async"
            />

            <div className="instagram-overlay">
              <FaInstagram />

              <span>
                Ver publicación
              </span>
            </div>
          </a>
        ))}
      </div>

      {/* BOTÓN FINAL */}

      <a
        href={instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="instagram-button"
      >
        <FaInstagram />

        Ver perfil en Instagram

        <FaArrowRight />
      </a>

      {/* LOGO DECORATIVO */}

      <img
        src={logo}
        alt="YANNA A&P Constructions"
        className="instagram-logo"
        loading="lazy"
        decoding="async"
      />
    </section>
  );
}

export default InstagramSection;